export default "__VITE_ASSET__DMbGZdVj__"